<template>                    
    
    <v-layout row>
        <v-flex xs5>
            <v-select                        
                label="Auswahl Adressen"
                autocomplete
                v-bind:loading="loading"
                dark
                multiple
                cache-items
                chips
                required
                v-bind:items="adressen"     
                item-text="strasse"
                item-value="id"
                return-object
                v-bind:search-input.sync="search"
                v-model="fa.adressen"></v-select>
        </v-flex>

        <v-flex xs6 offset-xs1> 
            <v-layout row wrap>
                <v-flex xs6 v-for="(adresse,index) in fa.adressen" v-bind:key="index">
                    <p><strong> {{ adresse.strasse }} </strong></br>
                        {{ adresse.plz }} {{ adresse.ort }} 
                    </p>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
       

</template>

<script>

export default {
    
    data() {
        return {           
                     
            search: null,            
        };
    },
    watch: {
      search (val) {
        val && this.querySelections(val)
      }
    },
    
    computed: {
        adressen: function() {
            
            return this.$store.getters.adressen
        },
        fa: function() {
            return this.$store.getters.firma
        },
        loading: function() {
            return this.$store.getters.loading
        }
    },
    methods: {

        querySelections (v) {
                       
            this.fa.adressen = this.adressen.filter(e => {
                    return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
            })

        
        },
              
    },
    
}
    
</script>

<style>
    
    
    
</style>


// WEBPACK FOOTER //
// adressenSelect.vue?193e61a3